module.exports = __webpack_public_path__ + "static/img/輾二-賴培銘.1ac1525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/輾二-賴培銘.jpg
// module id = xUAt
// module chunks = 1